const globalAPI = {
    mainApi: 'https://jwexam.dnedu.com.cn/gwTeaching_service/gwteaching_service/',
    fileApi: 'https://imgs.dnedu.com.cn',
    uploadApi: 'https://jwexam.dnedu.com.cn/gwTeaching_service/fileimage_service/minio/upload',
    uploadBase64Api: 'https://jwexam.dnedu.com.cn/gwTeaching_service/fileimage_service/minio/uploadBase64',

}
module.exports = globalAPI;


// WEBPACK FOOTER //
// ./src/plugin/api.js